<template>
	<div class="latform-hypertalk-container">
		<div class="title">
			动态列表
		</div>
		<div class="commentBoxList" v-if="updatesData.length">
			<div class="comment" v-for="(item,index) in updatesData" :key="index">
				<div class="userInfoBox">
					<div class="userInfo">
						<img class="avatar" :src="item.avatar" v-if="item.avatar" />
						<img class="avatar" src="../../assets/defaultAvatar.png" v-else />
						<div class="nameTimeIdentity">
							<div class="nameBox">
								{{item.user_nickname}}
							</div>
							<div class="time">
								{{item.create_time}}
							</div>
						</div>
					</div>
					<div class="reportBox">
						<img class="reportIcon" src="../../assets/Personal/iconC.png" @click="editComment(item)" />
						<img class="reportIcon" src="../../assets/Personal/iconB.png" @click="delComment(item)" />
					</div>
				</div>
				<div class="commentContentBox">
					<div class="contentText" v-html="item.content.replace(/\n/g, '<br/>')">
					</div>
					<div class="tip">
						#{{item.title}}-{{item.fenqu}}
						<img class="arrow" src="../../assets/Personal/iconH.png" />
					</div>
					<div class="imgList">
						<el-image class="imgItem" fit="cover" :src="row" :preview-src-list="item.banner"
							v-for="(row,rowIndex) in item.banner" :key="rowIndex">
						</el-image>
					</div>
				</div>
				<div class="commentMenuBox">
					<div class="commentMenuItem">
						<img class="icon" src="../../assets/Home/commentTwo.png" />
						{{item.dt_count}}
					</div>
					<div class="commentMenuItem">
						<img class="icon" src="../../assets/Home/like.png" />
						{{item.dz_num}}
					</div>
				</div>
			</div>
		</div>
		<el-empty description="暂无数据" v-else></el-empty>
		<div class="popContainer" v-if="dialogSendViable">
			<div class="dialogContent">
				<div class="title">
					动态发布
					<img class="close" src="../../assets/Feedback/close.png" @click="closeReply" />
				</div>
				<div class="tips">
					温馨提示：<span>岱屿画境平台监督小客服，提示您发布健康的内容哦!</span>
				</div>
				<div class="replyContent">
					<textarea v-model="content" maxlength="200" placeholder="请输入回复内容"></textarea>
					<div class="textNum">
						<span>{{content.length}}</span>/200
					</div>
				</div>
				<div class="imgList">
					<div class="imgItem" v-for="(item,index) in imgList" :key="index">
						<img class="imgItemImg" :src="item" />
						<img class="delete" @click="imgList.splice(index, 1)" src="../../assets/Feedback/delete.png" />
					</div>
					<div class="addImgBox" @click="uploadPhoto" v-if="imgList.length != 6">
						<img class="addImg" src="../../assets/Feedback/addImg.png" />
						上传图片
					</div>
				</div>
				<div class="submit" @click="communityAdd">提交</div>
			</div>
		</div>
		<PagePagination style="padding: .32rem 0 0rem;" :currentPage="currentPage" :total="total"
			@current-change="onPageChange" />
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="successTitle"
			@clickOk="publishPop = false;closeReply()" v-if="publishPop" />
		<PopToast :imgPtahUrl="require('@/assets/Register/fail.png')" :desc="'发布失败'"
			:subTitle="'平台 AI 智能图文检测未通过请您修改后再提交'" @clickOk="publishFailPop = false;closeReply()"
			v-if="publishFailPop" />
		<el-upload ref="upload" style="line-height: 0;height: 0;" name="image"
			action="https://ht.daiyuart.com/api.php/set/Other/upload_img" :show-file-list="false" :limit="6" multiple
			:on-success="handlePhotoSuccess">
		</el-upload>
	</div>
</template>

<script>
	import PopToast from '../../components/PopToast.vue'
	export default {
		name: 'MyUpdates',
		components: {
			PopToast
		},
		data() {
			return {
				publishPop: false,
				publishFailPop: false,
				imgList: [],
				content: '',
				curUpdates: {},
				updatesData: [],
				successTitle: '',
				dialogSendViable: false,
				currentPage: 1,
				total: 0,
			}
		},
		mounted() {
			this.myDtList()
		},
		methods: {
			onPageChange(newPage) {
				this.currentPage = newPage
				this.myDtList()
			},
			uploadPhoto() {
				this.$refs.upload.$el.querySelector('input').click();
			},
			handlePhotoSuccess(response) {
				this.imgList.push(response.data)
			},
			myDtList() {
				this.$api.post('Release/my_dt_list', {
					p: this.currentPage
				}).then(res => {
					if (res.code == 1) {
						this.total = res.data.count
						this.updatesData = res.data.list
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//Release/dt_edit 编辑动态
			delComment(item) {
				this.$confirm('确认删除当前动态吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('Release/dt_del', {
						id: item.id
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.myDtList()
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(() => {

				});
			},
			editComment(item) {
				this.curUpdates = {
					content: item.content,
					banner: item.banner,
					id: item.id
				}
				this.content = this.curUpdates.content
				this.imgList = [...item.banner]
				this.dialogSendViable = true
				document.body.style.overflow = 'hidden';
			},
			communityAdd() {
				if (!this.content) return this.$message.warning('请输入回复内容')
				this.$api.post('/Release/dt_edit', {
					id: this.curUpdates.id,
					content: this.content,
					banner: this.imgList.join(','),
				}).then(res => {
					this.dialogSendViable = false
					if (res.code == 1) {
						this.successTitle = '编辑成功'
						this.publishPop = true
						this.myDtList()
					} else {
						this.publishFailPop = true
					}
				}).catch(err => {
					this.$message.error('发布动态失败，请稍后再试！')
					console.log(err);
				})
			},
			closeReply() {
				this.content = ''
				this.imgList = []
				this.dialogSendViable = false
				document.body.style.overflow = '';
			}
		}
	}
</script>

<style lang="scss" scoped>
	.latform-hypertalk-container {
		margin: .24rem .24rem;
		display: flex;
		flex-direction: column;
		background: #FFFFFF;
		border-radius: .08rem;
		padding: .24rem .4rem;
	}

	.title {
		font-weight: 600;
		font-size: .16rem;
		color: #333333;
	}

	.commentBoxList {
		display: flex;
		flex-direction: column;

		.comment {
			margin-top: .24rem;
			display: flex;
			flex-direction: column;

			.userInfoBox {
				display: flex;
				align-items: center;
				justify-content: space-between;

				.userInfo {
					display: flex;
					align-items: center;

					.avatar {
						width: .5rem;
						height: .5rem;
						border-radius: 50%;
						overflow: hidden;
						object-fit: cover;
					}

					.nameTimeIdentity {
						margin-left: .16rem;
						display: flex;
						flex-direction: column;

						.nameBox {
							font-weight: bold;
							font-size: .16rem;
							color: #312C28;
						}

						.time {
							font-weight: 400;
							font-size: .12rem;
							color: #999999;
						}
					}
				}

				.reportBox {
					display: flex;
					align-items: center;

					.reportIcon {
						width: .18rem;
						height: .18rem;
						margin-left: .16rem;
						cursor: pointer;
					}
				}
			}

			.commentContentBox {
				margin: .12rem .48rem 0 .62rem;
				display: flex;
				flex-direction: column;

				.contentText {
					font-weight: 400;
					font-size: .16rem;
					color: #312C28;
					line-height: .24rem;
				}

				.tip {
					margin-top: .1rem;
					display: flex;
					align-items: center;
					width: fit-content;
					height: .32rem;
					background: #FAEFDD;
					border-radius: .04rem;
					line-height: .32rem;
					padding: 0 .12rem;
					font-weight: 400;
					font-size: .14rem;
					color: #000000;

					.arrow {
						width: .04rem;
						height: .06rem;
						margin-left: .04rem;
					}
				}

				.imgList {
					display: flex;
					flex-wrap: wrap;

					.imgItem {
						margin-top: .12rem;
						margin-right: .12rem;
						width: 1.54rem;
						height: 2.06rem;
						border-radius: .08rem;
					}
				}
			}

			.commentMenuBox {
				margin: .24rem .48rem 0 .84rem;
				display: flex;
				align-items: center;

				.commentMenuItem {
					width: .72rem;
					display: flex;
					align-items: center;
					font-weight: 400;
					font-size: .14rem;
					color: #666666;

					.icon {
						margin-right: .08rem;
						width: .16rem;
						height: .16rem;
					}
				}
			}

		}
	}

	.popContainer {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(0, 0, 0, 0.5);
		z-index: 102;

		.dialogContent {
			width: 7.4rem;
			background: #FFFFFF;
			border-radius: .12rem;
			display: flex;
			flex-direction: column;
			padding: .24rem .24rem;

			.title {
				display: flex;
				align-items: center;
				justify-content: space-between;
				font-weight: 500;
				font-size: .18rem;
				color: #252525;
				line-height: .26rem;

				.close {
					width: .14rem;
					height: .14rem;
					cursor: pointer;
				}
			}

			.tips {
				margin-top: .24rem;
				display: flex;
				align-items: center;
				font-weight: 400;
				font-size: .14rem;
				color: #252525;
				line-height: .2rem;

				span {
					font-weight: 500;
					color: #312C28;
				}
			}

			.replyContent {
				margin-top: .24rem;
				width: 6.92rem;
				height: 1.6rem;
				background: #FFFFFF;
				border-radius: .04rem;
				border: .01rem solid #EFD8B8;
				position: relative;

				.textNum {
					position: absolute;
					right: .12rem;
					bottom: .12rem;
					display: flex;
					align-items: center;
					font-weight: 400;
					font-size: .14rem;
					color: #999999;
					line-height: .2rem;

					span {
						color: #252525;
					}
				}

				textarea {
					width: 100%;
					height: 100%;
					border: none;
					padding: .12rem .12rem;
					font-weight: 400;
					font-size: .14rem;
				}
			}

			.imgList {
				margin-top: .24rem;
				display: flex;
				flex-wrap: wrap;

				.imgItem {
					margin-right: .16rem;
					display: flex;
					width: .86rem;
					height: .86rem;
					border-radius: .04rem;
					overflow: hidden;
					position: relative;

					.delete {
						position: absolute;
						top: .05rem;
						right: .05rem;
						width: .14rem;
						height: .14rem;
						cursor: pointer;
					}

					.imgItemImg {
						width: .86rem;
						height: .86rem;
						object-fit: cover;
					}
				}

				.addImgBox {
					width: .86rem;
					height: .86rem;
					border-radius: .04rem;
					background: #FFFFFF;
					border: 1px solid #EFD8B8;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					font-weight: 400;
					font-size: .12rem;
					color: #999999;
					cursor: pointer;

					.addImg {
						margin-bottom: .08rem;
						width: .27rem;
						height: .23rem;
					}
				}
			}

			.submit {
				margin: .32rem auto 0;
				width: 1.3rem;
				height: .36rem;
				background: #E29358;
				border-radius: .04rem;
				font-weight: 400;
				font-size: .14rem;
				color: #252525;
				text-align: center;
				line-height: .36rem;
				cursor: pointer;
			}
		}
	}
</style>